class FeaturedCollection extends HTMLElement {
  constructor () {
    
    super();

    this.isProductRecommendations = this.dataset.featuredCollection === "true"
    this.scrollableContainer = this.querySelector('.collection')
    // Only continue setup if there's content to show..
    if (this.scrollableContainer) {
      this.initComponent()
    // Product recommendations needs to fetch the HTML using JS, parse the HTML data, 
    // render the data to the DOM and then run the initComponent() menthod
    } else if (this.isProductRecommendations) {
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
        const innerHTML = new DOMParser()
        .parseFromString(text, 'text/html')
        .querySelector('featured-collection');
        if ( innerHTML && innerHTML.querySelectorAll('.product-item').length > 0 ) {
          innerHTML.querySelectorAll('img').forEach((img) => {
            img.classList.add('lazyloaded');
          })
          console.log(innerHTML)
          this.innerHTML = innerHTML.innerHTML;
          // this.querySelector('.collection').classList.add('wrapper');
          this.initComponent();
        // document.querySelector('.shopify-section-product-recommendations').classList.add('section-w-margin');
        } 
        })
        .catch(e => {
        console.error(e);
        });
        }
      
      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  initComponent() {
    this.nextButton = this.querySelector('#fc-button-next')
    this.prevButton = this.querySelector('#fc-button-prev')
    this.scrollableContainer = this.querySelector('.collection')
    this.currentIndexEl = this.querySelector('#fc-counter-1')

    this.maxIndex = this.scrollableContainer.childElementCount
    this.index = 1;
    this.querySelector('#fc-counter-1').innerHTML = this.index;
    this.querySelector('#fc-counter-2').innerHTML = this.maxIndex;

    this.nextButton.addEventListener('click', this.scrollForward.bind(this))
    this.prevButton.addEventListener('click', this.scrollBackward.bind(this))

    this.scrollableContainer.addEventListener('scroll', (e) => {
      this.checkIndex()
    })
  }
  
  scrollForward() {
    if (this.index >= this.maxIndex) return
    this.scrollBy(this.getSlideWidth());
  }

  scrollBackward() {
    // if (this.index <= 1) return
    this.scrollBy(-1 *(this.getSlideWidth()));
  }

  scrollBy(amount) {
    this.scrollableContainer.scrollBy({
      left: amount * .5,
      behavior: 'smooth'
    })
  }
  
  getSlideWidth() {
    return this.scrollableContainer.querySelector('.product-item').offsetWidth;
  }

  checkIndex() {
    const scrolledBy = this.scrollableContainer.scrollLeft
    const slideWidth = this.getSlideWidth();
    const multiplier = document.body.clientWidth > 750 ? .85 : 1
    // adding 1 because slides start at 1 not 0
    const result = Math.floor(scrolledBy / (slideWidth * multiplier)) + 1
    
    if (this.index !== result) {
      this.index = result
      this.updateCurrentIndexEl()
    }
  }

  updateCurrentIndexEl() {
    this.currentIndexEl.textContent = this.index;
  }
  
}

customElements.define('featured-collection', FeaturedCollection);